"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPartInvestissementsDurablesTrads = void 0;
exports.ESubPartInvestissementsDurablesTrads = {
    between_0_25: "Entre 0% et 25%",
    between_26_50: "Entre 26% et 50%",
    between_51_75: "Entre 51% et 75%",
    between_76_100: "Entre 76% et 100%",
};
